export enum PartnershipType {
    Rational = 1,
    TerceirizacaoContabil = 2,
    Outros = 3,
    FiqueTranquilo = 4
}


// WEBPACK FOOTER //
// ./src/app/shared/enums/PartnershipType.ts